export function buildFormsPageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Forms.Queries.FormsPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

export function buildFormSettingsQueryV1(workspaceId: number, projectId: number, formId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Forms.Queries.FormSettingsQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'FormId': formId
	}
}


export function buildFormByIdQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Forms.Queries.FormByIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'FormId': formId
	}
}

export function buildFormDependenciesQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Forms.Queries.FormDependenciesQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'FormId': formId,
	}
}
